import { experienceApi } from "@/lib/api";

export const dismissOnboarding = async (): Promise<void> => {
  await experienceApi.post("/api/onboarding/dismiss");
};
